import React from "react";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { lowerCase, startCase } from "lodash";
import moment from "moment";
import { TableComponent } from "../table/TableComponent";
import Box from "@amzn/meridian/box";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close-medium";
import Icon from "@amzn/meridian/icon";
import { DEFAULT_DATE_FORMAT } from "../../utils/formattingUtils";
import { ICalendarTableProps } from "./definitions";

export const CalendarTable: React.FC<ICalendarTableProps> = ({
    calendarTableQuery,
    setCalendarTableQuery,
    calendarType,
    alias,
}) => {
    return (
        <Box backgroundColor={"principal"} spacingInset={"400"}>
            <Row width={"100%"} widths={["grid-4", "fill", "fit"]}>
                <Text
                    type={"h300"}
                >{` ${startCase(lowerCase(calendarTableQuery?.documentType))} due on ${moment(calendarTableQuery.date).format("MMM Do YY")}`}</Text>
                <div />
                <Button type="icon" onClick={() => setCalendarTableQuery(null)}>
                    <Icon tokens={closeMediumTokens} />
                </Button>
            </Row>
            <TableComponent
                tableQueryParams={{
                    ...(calendarType === "my-calendar" ? { assignedTo: alias } : null),
                    status: calendarTableQuery.status,
                    documentType: calendarTableQuery.documentType,
                    dueDate: moment(calendarTableQuery.date).format(DEFAULT_DATE_FORMAT),
                }}
                tableUseCase={"GET_DOCUMENTS"}
                tableName={"calender-event"}
            />
        </Box>
    );
};
